module.exports = __webpack_public_path__ + "img/DocNoSend.f8d2ef3c.png";